<template>
  <div class="ds-control mobile dsf_teas_attendance_detail">
    <div class="search">
      <van-search v-model="keywords" shape="round" @input="search" placeholder="搜索" />
    </div>
    <div class="top_statistics">
      <div class="attendance_rank" v-if="systemArr.length && systemArr.length!==1 && systemArr.length!==5">
        <span>{{ totalObj.attendRate }}%</span>
        <div>考勤率</div>
      </div>
      <div class="other_rank" :class="[!systemArr.length || systemArr.length==1 || systemArr.length==5?'other_width':'']">
        <div class="attendance" v-if="!systemArr.length || systemArr.length==1 || systemArr.length==5">
          <span>{{ totalObj.attendRate }}%</span>
          <div>考勤率</div>
        </div>
        <div>
          <div class="statistics_item" :class="[!chooseValue?'choose_value':'']" @click="changeBtn('')">
            <span>{{ totalObj.should }}</span>
            <div>应到</div>
          </div>
        </div>
        <div v-if="systemArr.includes('1')">
          <div class="statistics_item" :class="[chooseValue=='1'?'choose_value':'']" @click="changeBtn('1')">
            <span>{{ totalObj.onTime }}</span>
            <div>出勤</div>
          </div>
        </div>
        <div>
          <div class="statistics_item" :class="[chooseValue=='6,7,8'?'choose_value':'']" @click="changeBtn('6,7,8')">
            <span>{{ totalObj.leave }}</span>
            <div>请假</div>
          </div>
        </div>
        <div v-if="systemArr.includes('2')">
          <div class="statistics_item" :class="[chooseValue=='2'?'choose_value':'']" @click="changeBtn('2')">
            <span>{{ totalObj.late }}</span>
            <div>迟到</div>
          </div>
        </div>
        <div v-if="systemArr.includes('3')">
          <div class="statistics_item" :class="[chooseValue=='3'?'choose_value':'']" @click="changeBtn('3')">
            <span>{{ totalObj.seriousLate }}</span>
            <div>晚到</div>
          </div>
        </div>
        <div v-if="systemArr.includes('4')">
          <div class="statistics_item" :class="[chooseValue=='4'?'choose_value':'']" @click="changeBtn('4')">
            <span>{{ totalObj.early }}</span>
            <div>早退</div>
          </div>
        </div>
        <div>
          <div class="statistics_item" :class="[chooseValue=='9'?'choose_value':'']" @click="changeBtn('9')">
            <span>{{ totalObj.notSign }}</span>
            <div>未签</div>
          </div>
        </div>
      </div>
    </div>
    <div class="all_select" v-if="showSelect" @click="allSelect">
      <van-checkbox v-model="allCheck"></van-checkbox>
      全选(已选 {{selectNum}} 人)
    </div>
    <div class="list" v-if="list.length > 0">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :error.sync="error" @load="getList">
          <!-- <div class="list-item" v-for="(item, index) in list" :key="index"> -->
          <!-- <div class="cell name">{{ item.name }}</div>
            <div class="cell group">{{ item.groupText }}</div>
            <div class="cell position">{{ item.job }}</div>
            <div
              class="status"
              :class="{
                chuqin: item.resultValue === '1',
                gongjia: '678'.indexOf(item.resultValue) !== -1,
                weiqian: '1678'.indexOf(item.resultValue) === -1,
              }"
              @click="changeStatus(item.userId)">
              {{ item.resultText }}
            </div> -->

          <!-- </div> -->
          <DsfMobileTeasCell class="list-item" v-for="(item, index) in list" border :headerUrl="item.photo || defaultImg" cellShape="square" :key="index" :title="item.name" @click.native="itemClick(item,index)">
            <div class="radio_value" slot="front" v-if="showSelect">
              <van-checkbox v-model="item.radioValue"></van-checkbox>
            </div>
            <DsfMobileTeasCellItem :value="item.groupText || '暂无'"></DsfMobileTeasCellItem>
            <DsfMobileTeasCellItem :value="item.job || '暂无'"></DsfMobileTeasCellItem>
            <div
              v-if="!showSelect"
              slot="titleRight"
              class="status"
              :class="{
                chuqin: item.resultValue === '1',
                gongjia: '678'.indexOf(item.resultValue) !== -1,
                weiqian: '1678'.indexOf(item.resultValue) === -1,
              }"
              @click="changeStatus(item.userId)">
              {{ item.resultText }}
            </div>
          </DsfMobileTeasCell>
        </van-list>
      </van-pull-refresh>
      <div class="zw_div"></div>
      <div class="all_btn">
        <div class="batch" @click="batchOperation" v-if="!showSelect">批量操作</div>
        <div class="cancel" v-if="showSelect" @click="cancelSelect">取消</div>
        <div class="modify" v-if="showSelect" @click="modifySelect">修改状态</div>
      </div>
    </div>
    <van-empty v-else description="暂无数据" />
    <van-popup v-model="showStatus" round position="bottom">
      <van-picker show-toolbar :columns="statusOption" @cancel="showStatus = false" @confirm="onConfirm" />
    </van-popup>
    <!-- 二维码弹窗 -->
    <van-dialog v-model="showQrCode" :show-confirm-button="false" close-on-click-overlay width="300px">
      <div class="dialog_head">
        <i class="iconfont icon-guanbi3" @click="showQrCode=false"></i>
      </div>
      <div class="dialog_content">
        <p class="title">考勤二维码</p>
        <img :src="qrCodeSrc" />
        <div class="value"><span>{{timerNum}}</span>秒后刷新</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
const testData = [];
export default dsf.component({
  name: "DsfMobileTeasAttendanceDetail",
  mixins: [$mixins.control],
  ctrlCaption: "考勤详情",
  design: {
    isMask: false,
  },
  props: {
    // 列表接口
    sourcesUrl: {
      type: String,
      default: "/teas/mobile/attendance/queryAttendResultByClass",
    },
    // 获取状态选项接口
    statusUrl: {
      type: String,
      default: "/teas/mobile/attendance/queryAttendStatus",
    },
    // 手动更新状态接口
    updateStatusUrl: {
      type: String,
      default: "/teas/mobile/attendance/updateAttendStatus",
    },
  },
  watch: {
    showQrCode: function (newVal, oldVal) {
      console.log(newVal, oldVal, 111);
      if (!newVal) {
        clearInterval(this.timer)
      }
    },
  },
  data() {
    return {
      defaultImg: dsf.config.setting_public_user_default_header,
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      isCanChangeStatus: false, // 是否可以更改状态
      keywords: "",
      pageNum: 0,
      list: [],
      totalObj: {
        attendRate: "0%",
        late: 0,
        seriousLate: 0,
        early: 0,
        notSign: 0,
        should: 0,
        onTime: 0,
        leave: 0,
      },
      // 更改状态的用户id
      statusUserId: "",
      showStatus: false,
      showSelect: false,
      statusOption: [],
      systemArr: [],
      chooseValue: '',
      selectNum: 0,//选择人数
      allCheck: false,//全选按钮状态
      showQrCode: false,//二维码弹窗
      codeData: {},
      timerNum: 30,
      qrCodeSrc: '',
      timer: ''//定时器
    };
  },
  created() {
    if (this.isDesign) {
      this.list = testData;
    } else {
      this.classId = this.$route.query.classId;
      this.relId = this.$route.query.relId;
      this.getList();
      this.getSystem();
      this.getStatusOption();
    }
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    getWebPath() {
      let date = new Date();
      let value = 'teas/attendance/qrcode?sourceType=' + this.totalObj.attendMode + '&id=' + this.relId + '&t=' + date.getTime()
      this.qrCodeSrc = dsf.url.getWebPath(value)
    },
    timerChange() {
      this.timerNum = this.codeData.refreshSecond;
      this.timer = setInterval(() => {
        this.timerNum--;
        if (this.timerNum < 0) {
          this.getWebPath()
          this.timerNum = this.codeData.refreshSecond;
        }
      }, 1000)
    },
    // 点击导航栏二维码事件
    qrCodeClick() {
      this.$http.get('teas/attendance/getSystemQrCodeConfig').done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.codeData = res.data;
          this.showQrCode = true;
          this.getWebPath()
          // 判断是否打开定时器
          if (res.data.codeRefreshValue == '1') {
            this.timerChange()
          }
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
        });
    },
    // 批量操作
    batchOperation() {
      this.allCheck = false;
      this.showSelect = true;
      this.selectNum = 0;
      this.statusUserId = '';
      this.list.map(element => {
        element.radioValue = false;
      })
    },
    // 取消批量操作
    cancelSelect() {
      this.showSelect = false;
      this.list.map(element => {
        element.radioValue = false;
      })
    },
    // 切换头部选项
    changeBtn(val) {
      if (this.$listeners["change"]) {
        this.$dispatch("change", { val });
      } else {
        if (this.chooseValue !== val) {
          this.chooseValue = val
          this.showSelect = false;
          this.getList()
        }
      }
    },
    itemClick(item, index) {
      this.selectNum = 0;
      this.list[index].radioValue = !this.list[index].radioValue;
      this.list.forEach(element => {
        if (element.radioValue) {
          this.selectNum++;
        }
      });
      this.allCheck = this.list.every(item => item.radioValue)
    },
    allSelect() {
      this.allCheck = !this.allCheck;
      this.list.map(element => {
        element.radioValue = this.allCheck;
      })
      if (this.allCheck) {
        this.selectNum = this.list.length;
      } else {
        this.selectNum = 0;
      }
    },
    search: _.debounce(function () {
      this.onRefresh();
    }, 300),
    // 获取列表数据
    getList() {
      this.$http
        .get(this.$replace(this.sourcesUrl, this), {
          relId: this.relId,
          classId: this.classId,
          search: this.keywords,
          screenStatus: this.chooseValue,
          isGroup: this.queryString.isGroup || ''
        })
        .done((res) => {
          this.finished = true;
          if (res.success && res.state == 20000 && res.data) {
            var stuAttendResult = res.data.stuAttendResult;
            stuAttendResult = stuAttendResult.map(element => {
              element.radioValue = false
              return element;
            });
            this.list = JSON.parse(JSON.stringify(stuAttendResult))
            this.$delete(res.data, "stuAttendResult");
            this.totalObj = res.data;
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
        })
        .always(() => {
          this.finished = true;
          this.refreshing = false;
        });
    },
    getSystem() {
      this.$http.get('teas/attendance/getSystemAttendRules', {}).done((res) => {
        if (res.success && res.state == 20000 && res.data) {
          this.systemArr = res.data.split('^')
        } else {
          dsf.layer.message(res.message, false);
        }
      }).error((err) => {
        dsf.layer.message(err.message || "出错了，请重试", false);
      })
        .always(() => {
        });
    },
    // 刷新
    onRefresh() {
      this.getList();
      this.getSystem();
    },
    // 获取状态列表
    getStatusOption() {
      const loading = dsf.layer.loading();
      this.$http
        .get(this.$replace(this.statusUrl), {
          classId: this.classId,
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              this.isCanChangeStatus = true;
              this.statusOption = res.data.map((item) => {
                return {
                  text: item.value,
                  value: item.code,
                };
              });
            } else {
              this.isCanChangeStatus = false;
            }
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 更新出勤状态
    changeStatus(userid) {
      if (this.isCanChangeStatus) {
        this.statusUserId = userid;
        this.showStatus = true;
      }
    },
    modifySelect() {
      if (this.isCanChangeStatus) {
        this.showStatus = true;
      }
    },
    // 确定修改状态
    onConfirm(select) {
      this.showStatus = false;
      this.showSelect = false;
      const loading = dsf.layer.loading();
      var statusUserIdArr = [];
      if (!this.statusUserId) {
        this.list.forEach(element => {
          if (element.radioValue) {
            statusUserIdArr.push(element.userId)
          }
        })
      }
      this.$http
        .post(this.$replace(this.updateStatusUrl), {
          relId: this.relId,
          userId: this.statusUserId || statusUserIdArr.join(','),
          resultText: select.text,
          resultValue: select.value,
          classId: this.$route.query.classId,
          id: this.$route.query.id
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            dsf.layer.message("操作成功！", true);
            this.onRefresh();
          } else {
            dsf.layer.message(res.message, false);
            this.error = true;
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
          this.error = true;
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
});
</script>
